export const PORTAL_TYPES = {
  CLINICAL: 'Clinical',
  OPERATIONS: 'Operations',
  FACILITY: 'Facility',
} as const;

export type PortalType = (typeof PORTAL_TYPES)[keyof typeof PORTAL_TYPES];
